<script>
  import { VueMaskDirective as mask } from 'v-mask'
  import service from '../../../../domain/leiloes/services'
  import RelatorioLoading from './_RelatorioLoading'

  export default {
    components: {RelatorioLoading},
    nome: 'relatorio-leilao-fechamento',
    directives: {mask},
    data () {
      return {
        isLoading: false,
        leilao: null
      }
    },
    computed: {
    },
    mounted () {
    },
    activated () {
    },
    created () {
      this.isLoading = true
      service.getLeilaoFechamento(this.$route.params.id)
        .then((response) => {
          this.isLoading = false
          this.leilao = response.data
        })
        .catch((response) => {
          this.isLoading = false
          console.log(response)
        })
    },
    deactivated () {
    },
    watch: {},
    methods: {
    }
  }
</script>

<template>
  <div class="r-container" :class="{'is-loading': isLoading}">
    <relatorio-loading v-if="isLoading"></relatorio-loading>
    <transition name="slide">
      <div v-if="!isLoading" class="content-transition relatorio-print" id="container-printer">

        <!--<div class="hidden-print">
          <div class="text-center m-t m-b-n">
            <h3 @click="showFiltros = !showFiltros" class="btn m-t-none"><span class="btn btn-default btn-xs m-r-xs">{{ !showFiltros ? '+' : '-' }}</span>Filtros</h3>
          </div>
          <div class="r-table" v-show="showFiltros">
            <div class="r-table-content">
              <div class="m-t">
                <div class="m-b">
                  <div>Tipo de Venda:</div>
                  <u-button-group v-model="filtro.tipo" :options="tiposLeilao"></u-button-group>
                </div>
                <div class="m-b">
                  <div>Situação:</div>
                  <u-button-group :multiSelect="true" v-model="filtro.situacao"
                                  :options="situacaoLote"></u-button-group>
                </div>
                <div class="m-b">
                  Resultados: {{ filteredData && filteredData.length }}
                </div>
              </div>
            </div>
          </div>
        </div>-->

        <div class="hidden-print">
          <h2 class="text-center text-uppercase font-bold m-b-none">FECHAMENTO DO LEILÃO</h2>
          <h4 class="text-center text-uppercase">Leilão Realizado {{ moment(leilao.dataAbertura.date).format('LLLL')
            }}</h4>
        </div>
        <div class="printer-page pos-rlt">
          <div class="visible-print">
            <h2 class="text-center text-uppercase font-bold m-b-none">FECHAMENTO DO LEILÃO</h2>
            <h4 class="text-center text-uppercase">Leilão Realizado {{ moment(leilao.dataAbertura.date).format('LLLL')
              }}</h4>
          </div>
          <div v-for="(fechamento, key) in leilao.fechamentos" :key="'fechamento-' + key"  class="r-table">
            <!--<div class="r-table-header">
              <div class="pull-left font-bold text-black">{{ lote.titulo }}</div>
              <div class="pull-right font-bold"><h3 class="m-t-none">Lote {{ lote.numero }}</h3></div>
              <div class="clearfix"></div>
            </div>-->
            <div v-if="fechamento.comitente">
              <div class="printer-page"></div>
              <br>
              <h4 class="text-center text-uppercase" style="margin-top: 20px">{{fechamento.comitente.pessoa.nome}}</h4>
            </div>
            <div class="r-table-content">
              <!--<table class="w-fh4 class="text-center text-uppercase">Leilão Realizado {{ moment(leilao.dataAbertura.date).format('LLLL')
                <tr>
                  <td>Comitente: <strong>{{ lote.comitente.pessoa.nome }}</strong></td>
                  <td class="text-right">Situação: <strong :class="'text-' + Status.Status[lote.status].class">{{
                    Status.Status[lote.status].titulo }}</strong></td>
                </tr>
                <tr>
                  <td>Quantidade de lances: <strong>{{ lote.lances ? lote.lances.length : 0 }}</strong></td>
                  <td class="text-right"><span v-if="lote.arremate">Vencedor: <strong>&lt;!&ndash;{{ lote.arremate.arrematante.pessoa.nome }}&ndash;&gt; {{ lote.arremate.arrematante.apelido }}</strong></span></td>
                </tr>
              </table>-->

              <table class="table table-bordered r-table-min text-center">
                <!--<thead>
                <tr>
                  <th>Quantidade de lotes</th>
                  <th>Apelido</th>
                </tr>
                </thead>-->
                <tbody>
                <tr class="font-bold">
                  <td style="width: 30%"></td>
                  <td colspan="2">Lotes</td>
                  <td>Valor</td>
                  <td>FIPE</td>
                </tr>
                <tr class="font-bold">
                  <td style="width: 30%"></td>
                  <td>Qtd</td>
                  <td>%</td>
                  <td>R$</td>
                  <td>%</td>
                </tr>
                <tr class="font-bold">
                  <td style="width: 30%">Total Geral do Leilão</td>
                  <td>{{ fechamento.stats.total.quantidade }}</td>
                  <td>100%</td>
                  <td>{{ fechamento.stats.total.valorMinimo|moeda }}</td>
                  <td>{{ fechamento.stats.total.pctFipe|number }}%</td>
                </tr>
                <tr class="font-bold">
                  <td style="width: 30%">Retirados</td>
                  <td>{{ fechamento.stats.retirados.quantidade }}</td>
                  <td>{{ fechamento.stats.retirados.pct|moeda }}%</td>
                  <td>{{ fechamento.stats.retirados.valorMinimo|moeda }}</td>
                  <td>{{ fechamento.stats.retirados.pctFipe|number }}%</td>
                </tr>
                <tr class="font-bold text-info">
                  <td style="width: 30%; color: #0c72cb !important;-webkit-print-color-adjust: exact;">Abertura do Pregão</td>
                  <td style="color: #0c72cb !important;-webkit-print-color-adjust: exact;">{{ fechamento.stats.abertura.quantidade }}</td>
                  <td style="color: #0c72cb !important;-webkit-print-color-adjust: exact;">{{ fechamento.stats.abertura.pct|moeda }}%</td>
                  <td style="color: #0c72cb !important;-webkit-print-color-adjust: exact;">{{ fechamento.stats.abertura.valorMinimo|moeda }}</td>
                  <td style="color: #0c72cb !important;-webkit-print-color-adjust: exact;">{{ fechamento.stats.abertura.pctFipe|number }}%</td>
                </tr>
                <tr class="font-bold text-info" style="-webkit-print-color-adjust: exact!important;">
                  <td style="width: 30%"></td>
                  <td>&nbsp;</td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr class="font-bold">
                  <td colspan="100%">Resultado Geral de Vendas</td>
                </tr>
                <tr class="font-bold">
                  <td style="width: 30%">Recuperáveis</td>
                  <td>{{ fechamento.stats.recuperaveis.quantidade }}</td>
                  <td>{{ fechamento.stats.recuperaveis.pct|moeda }}%</td>
                  <td>{{ fechamento.stats.recuperaveis.valorMinimo|moeda }}</td>
                  <td>{{ fechamento.stats.recuperaveis.pctFipe|number }}%</td>
                </tr>
                <tr class="font-bold_">
                  <td style="width: 30%">Vendidos</td>
                  <td>{{ fechamento.stats.recuperaveis.vendidos.quantidade }}</td>
                  <td>{{ fechamento.stats.recuperaveis.vendidos.pct|moeda }}%</td>
                  <td>{{ fechamento.stats.recuperaveis.vendidos.valorMinimo|moeda }}</td>
                  <td>{{ fechamento.stats.recuperaveis.vendidos.pctFipe|number }}%</td>
                </tr>
                <tr class="font-bold_">
                  <td style="width: 30%">Não Vendidos</td>
                  <td>{{ fechamento.stats.recuperaveis.naoVendidos.quantidade }}</td>
                  <td>{{ fechamento.stats.recuperaveis.naoVendidos.pct|moeda }}%</td>
                  <td>{{ fechamento.stats.recuperaveis.naoVendidos.valorMinimo|moeda }}</td>
                  <td>{{ fechamento.stats.recuperaveis.naoVendidos.pctFipe|number }}%</td>
                </tr>
                <tr class="font-bold text-info" style="-webkit-print-color-adjust: exact!important;">
                  <td style="width: 30%"></td>
                  <td>&nbsp;</td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr class="font-bold">
                  <td style="width: 30%">Sucatas</td>
                  <td>{{ fechamento.stats.sucatas.quantidade }}</td>
                  <td>{{ fechamento.stats.sucatas.pct|moeda }}%</td>
                  <td>{{ fechamento.stats.sucatas.valorMinimo|moeda }}</td>
                  <td>{{ fechamento.stats.sucatas.pctFipe|number }}%</td>
                </tr>
                <tr class="font-bold_">
                  <td style="width: 30%">Vendidos</td>
                  <td>{{ fechamento.stats.sucatas.vendidos.quantidade }}</td>
                  <td>{{ fechamento.stats.sucatas.vendidos.pct|moeda }}%</td>
                  <td>{{ fechamento.stats.sucatas.vendidos.valorMinimo|moeda }}</td>
                  <td>{{ fechamento.stats.sucatas.vendidos.pctFipe|number }}%</td>
                </tr>
                <tr class="font-bold_">
                  <td style="width: 30%">Não Vendidos</td>
                  <td>{{ fechamento.stats.sucatas.naoVendidos.quantidade }}</td>
                  <td>{{ fechamento.stats.sucatas.naoVendidos.pct|moeda }}%</td>
                  <td>{{ fechamento.stats.sucatas.naoVendidos.valorMinimo|moeda }}</td>
                  <td>{{ fechamento.stats.sucatas.naoVendidos.pctFipe|number }}%</td>
                </tr>
                <tr class="font-bold text-info" style="-webkit-print-color-adjust: exact!important;">
                  <td style="width: 30%"></td>
                  <td>&nbsp;</td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr class="font-bold">
                  <td style="width: 30%">Condicionais</td>
                  <td>{{ fechamento.stats.condicionais.quantidade }}</td>
                  <td>{{ fechamento.stats.condicionais.pct|moeda }}%</td>
                  <td>{{ fechamento.stats.condicionais.valorMinimo|moeda }}</td>
                  <td>{{ fechamento.stats.condicionais.pctFipe|number }}%</td>
                </tr>
                <tr class="font-bold_">
                  <td style="width: 30%">Recuperáveis Liberadas</td>
                  <td>{{ fechamento.stats.condicionais.recuperaveisLiberados.quantidade }}</td>
                  <td>{{ fechamento.stats.condicionais.recuperaveisLiberados.pct|moeda }}%</td>
                  <td>{{ fechamento.stats.condicionais.recuperaveisLiberados.valorMinimo|moeda }}</td>
                  <td>{{ fechamento.stats.condicionais.recuperaveisLiberados.pctFipe|number }}%</td>
                </tr>
                <tr class="font-bold_">
                  <td style="width: 30%">Recuperáveis em Análise</td>
                  <td>{{ fechamento.stats.condicionais.recuperaveisEmAnalise.quantidade }}</td>
                  <td>{{ fechamento.stats.condicionais.recuperaveisEmAnalise.pct|moeda }}%</td>
                  <td>{{ fechamento.stats.condicionais.recuperaveisEmAnalise.valorMinimo|moeda }}</td>
                  <td>{{ fechamento.stats.condicionais.recuperaveisEmAnalise.pctFipe|number }}%</td>
                </tr>
                <tr class="font-bold_">
                  <td style="width: 30%">Sucatas Liberadas</td>
                  <td>{{ fechamento.stats.condicionais.sucatasLiberados.quantidade }}</td>
                  <td>{{ fechamento.stats.condicionais.sucatasLiberados.pct|moeda }}%</td>
                  <td>{{ fechamento.stats.condicionais.sucatasLiberados.valorMinimo|moeda }}</td>
                  <td>{{ fechamento.stats.condicionais.sucatasLiberados.pctFipe|number }}%</td>
                </tr>
                <tr class="font-bold_">
                  <td style="width: 30%">Sucatas em Análise</td>
                  <td>{{ fechamento.stats.condicionais.sucatasEmAnalise.quantidade }}</td>
                  <td>{{ fechamento.stats.condicionais.sucatasEmAnalise.pct|moeda }}%</td>
                  <td>{{ fechamento.stats.condicionais.sucatasEmAnalise.valorMinimo|moeda }}</td>
                  <td>{{ fechamento.stats.condicionais.sucatasEmAnalise.pctFipe|number }}%</td>
                </tr>
                <tr class="font-bold_">
                  <td style="width: 30%">Total Liberadas</td>
                  <td>{{ fechamento.stats.condicionais.liberadas.quantidade }}</td>
                  <td>{{ fechamento.stats.condicionais.liberadas.pct|moeda }}%</td>
                  <td>{{ fechamento.stats.condicionais.liberadas.valorMinimo|moeda }}</td>
                  <td>{{ fechamento.stats.condicionais.liberadas.pctFipe|number }}%</td>
                </tr>
                <tr class="font-bold_">
                  <td style="width: 30%">Total em Análise</td>
                  <td>{{ fechamento.stats.condicionais.emAnalise.quantidade }}</td>
                  <td>{{ fechamento.stats.condicionais.emAnalise.pct|moeda }}%</td>
                  <td>{{ fechamento.stats.condicionais.emAnalise.valorMinimo|moeda }}</td>
                  <td>{{ fechamento.stats.condicionais.emAnalise.pctFipe|number }}%</td>
                </tr>
                <tr class="font-bold text-info" style="-webkit-print-color-adjust: exact!important;">
                  <td style="width: 30%"></td>
                  <td>&nbsp;</td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr class="font-bold">
                  <td style="width: 30%; color: #0c72cb !important;-webkit-print-color-adjust: exact;">Resultado Encerramento</td>
                  <td style="width: 30%; color: #0c72cb !important;-webkit-print-color-adjust: exact;">{{ fechamento.stats.resultado.encerramento.quantidade }}</td>
                  <td style="width: 30%; color: #0c72cb !important;-webkit-print-color-adjust: exact;">{{ fechamento.stats.resultado.encerramento.pct|moeda }}%</td>
                  <td style="width: 30%; color: #0c72cb !important;-webkit-print-color-adjust: exact;">{{ fechamento.stats.resultado.encerramento.totalVendas|moeda }}</td>
                  <td style="width: 30%; color: #0c72cb !important;-webkit-print-color-adjust: exact;">{{ fechamento.stats.resultado.encerramento.pctFipe|number }}%</td>
                </tr>
                <tr class="font-bold_">
                  <td style="width: 30%; color: #f50900 !important;-webkit-print-color-adjust: exact;">Condicionais em Análise</td>
                  <td style="width: 30%; color: #f50900 !important;-webkit-print-color-adjust: exact;">{{ fechamento.stats.resultado.condicionaisEmAnalise.quantidade }}</td>
                  <td style="width: 30%; color: #f50900 !important;-webkit-print-color-adjust: exact;">{{ fechamento.stats.resultado.condicionaisEmAnalise.pct|moeda }}%</td>
                  <td style="width: 30%; color: #f50900 !important;-webkit-print-color-adjust: exact;">{{ fechamento.stats.resultado.condicionaisEmAnalise.totalVendas|moeda }}</td>
                  <td style="width: 30%; color: #f50900 !important;-webkit-print-color-adjust: exact;">{{ fechamento.stats.resultado.condicionaisEmAnalise.pctFipe|number }}%</td>
                </tr>
                <tr class="font-bold">
                  <td style="width: 30%; color: #0c72cb !important;-webkit-print-color-adjust: exact; text-decoration: underline">Resultado Esperado</td>
                  <td style="width: 30%; color: #0c72cb !important;-webkit-print-color-adjust: exact; text-decoration: underline">{{ fechamento.stats.resultado.esperado.quantidade }}</td>
                  <td style="width: 30%; color: #0c72cb !important;-webkit-print-color-adjust: exact; text-decoration: underline">{{ fechamento.stats.resultado.esperado.pct|moeda }}%</td>
                  <td style="width: 30%; color: #0c72cb !important;-webkit-print-color-adjust: exact; text-decoration: underline">{{ fechamento.stats.resultado.esperado.totalVendas|moeda }}</td>
                  <td style="width: 30%; color: #0c72cb !important;-webkit-print-color-adjust: exact; text-decoration: underline">{{ fechamento.stats.resultado.esperado.pctFipe|number }}%</td>
                </tr>
                <tr class="font-bold text-info" style="-webkit-print-color-adjust: exact!important;">
                  <td style="width: 30%"></td>
                  <td>&nbsp;</td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr class="text-left">
                  <td colspan="100%">*Média (%) de Venda / FIPE: <strong>{{ fechamento.stats.resultado.mediaVendaFipe|number }}%</strong></td>
                </tr>
                <tr class="text-left">
                  <td colspan="100%">*Média (%) de Veículos Vendidos: <strong>{{ fechamento.stats.resultado.mediaVendaQtd|number }}%</strong></td>
                </tr>
                <tr class="text-left">
                  <td colspan="100%">*Ticket Médio por Lote R$ {{ fechamento.stats.resultado.ticketMedioPorLote|moeda }}</td>
                </tr>
                </tbody>
              </table>

            </div>
          </div>
          <!--<div class="p-page-numer visible-print">Página {{key+1}} de {{filteredData && filteredData.length}}</div>-->
        </div>
      </div>
    </transition>
  </div>
</template>



// WEBPACK FOOTER //
// RelatorioFechamento.vue?a4296c44